import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { RemoteContent, Title, useAuth } from '@jupi/ui'
import { useEnrolments } from '../../api/school'
import { EnrolmentCard } from '../../components/EnrolmentCard'

// The student's own courses. Progress and flights join this page when
// training flights are ported.
export default function MyTrainingPage() {
  const { t } = useTranslation()
  const { user } = useAuth()
  const { data: enrolments = [], isLoading, error } = useEnrolments({ studentUserId: user?.id })

  return (
    <Box>
      <Title label={t('nav.myTraining')} />
      <RemoteContent isLoading={isLoading} error={error}>
        {enrolments.length === 0 && !isLoading ? (
          <Typography color="text.secondary">{t('school.noEnrolments')}</Typography>
        ) : null}
        <Stack spacing={1.5}>
          {enrolments.map((enrolment) => (
            <EnrolmentCard key={enrolment.enrolmentId} enrolment={enrolment} />
          ))}
        </Stack>
      </RemoteContent>
    </Box>
  )
}
